import { motion } from 'framer-motion';
import Header from './Header';
import PageEdgeLines from './marketing/PageEdgeLines';
import CtaFooterBridge from './landing/CtaFooterBridge';
import MarketingFooterBridge from './marketing/MarketingFooterBridge';
import { EASE_LUXURY } from './marketing/constants';

export default function PageWrapper({
  children,
  withEdgeLines = true,
  cta,
  className = '',
}) {
  return (
    <div
      className={`min-h-screen flex flex-col bg-grain landing-page ${className}`.trim()}
      style={{ background: 'var(--bg-base)' }}
    >
      {withEdgeLines && (
        <>
          <PageEdgeLines side="left" />
          <PageEdgeLines side="right" />
        </>
      )}
      <Header />
      <motion.main
        className="flex-1 marketing-page-flow"
        initial={{ opacity: 0, y: 20, filter: 'blur(4px)' }}
        animate={{ opacity: 1, y: 0, filter: 'blur(0px)' }}
        transition={{ duration: 0.65, ease: EASE_LUXURY }}
      >
        {children}
      </motion.main>
      {cta ? <CtaFooterBridge cta={cta} /> : <MarketingFooterBridge />}
    </div>
  );
}
